import { render, staticRenderFns } from "./BrainInitiative.vue?vue&type=template&id=dcac78a4&"
import script from "./BrainInitiative.vue?vue&type=script&lang=js&"
export * from "./BrainInitiative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports